export const HELP_LINKS = {
  SUPPORT_EMAIL: process.env.REACT_APP_SUPPORT_EMAIL || 'cp-slc@adobe.com',
  FEEDBACK_FORM:
    'https://forms.office.com/pages/responsepage.aspx?id=Wht7-jR7h0OUrtLBeN7O4beptsewLNtFnTt9RuWeB7JUQjM2U0tUNlpCUU4wWEc5WTVaV085TUlEUy4u&route=shorturl'
};
